import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import "../../../../../App.css";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { clearReduxData } from "../../../../../data/redux/slice/clientOnboardDataSlice";
import { colorWhite } from "../../../../../utility/constants/colorManager";
import { validateIPaddress } from "../../../../../utility/emailValidator";

function BusinessDetailsNew({
  onClickBack,
  onClickNext,
  onClickPrevious,
  reduxData,
  onClickCancel,
}) {
  const [businessType, setBusinessType] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [websiteLink, setWebsiteLink] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [legalName, setLegalName] = useState("");
  const [dinCheck, setDinCheck] = useState("");
  const [dpanCheck, setDpanCheck] = useState("");
  const [ipAddress, setIpAddress] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //const removeData = useSelector((state) => state.onboardClientSlice);

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000",
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  const Categories = [
    {
      label: "Sole proprietorship",
      value: "SoleProprietorship",
    },
    {
      label: "Partnership",
      value: "Partnership",
    },
    {
      label: "Public",
      value: "Public",
    },
    {
      label: "Private Limited",
      value: "PrivateLimited",
    },
  ];

  function getValue(arr, finder) {
    return arr.find((data) => data.value === finder);
  }

  useEffect(() => {
    if (
      reduxData?.businessType &&
      reduxData?.gstNumber &&
      reduxData?.websiteLink &&
      reduxData?.businessName &&
      reduxData?.address &&
      reduxData?.legalName &&
      reduxData?.dpan &&
      reduxData?.dinNumber &&
      reduxData?.ipWhitelist
    ) {
      setBusinessType(getValue(Categories, reduxData?.businessType));
      setGstNumber(reduxData?.gstNumber);
      setWebsiteLink(reduxData?.websiteLink);
      setBusinessName(reduxData?.businessName);
      setBusinessAddress(reduxData?.address);
      setDinCheck(reduxData?.dinNumber);
      setDpanCheck(reduxData?.dpan);
      setLegalName(reduxData?.legalName);
      setIpAddress(reduxData?.ipWhitelist?.[0]);
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        height: "100%",
        marginTop: "20px",
      }}
    >
      <div>
        <p style={styles.title}>Business Details & IP white Listing </p>
      </div>
      <p style={styles.p}>Please provide the necessary details to proceed.</p>
      <div
        style={{
          margin: "10px 0px 0px 0px",
          height: "1px",
          background: "#38369C",
        }}
      ></div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "20px 0px 0px 0px",
          gap: 20,
          marginBottom: 20,
        }}
      >
        <div style={{ display: "flex" }}>
          <div style={{ minWidth: 275, marginRight: 75 }}>
            <label style={styles.label}>GST Number</label>
            <CustomInput
              value={gstNumber}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="GST Number"
              validator="gst"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
              onChange={(data) => {
                setGstNumber(data);
              }}
            />
          </div>

          {/* <CustomButton
            styles={{ marginTop: 5, padding: "15px 0px" }}
            // title={panValidate ? "Verified" : "Validate"}
            title={"Validate"}
            //   onClick={() => {
            //     if (!panValidate) {
            //       setLoading(!loading);
            //       // validateAccountWithPennyDrop({
            //       //   accNo: remitterAccountNumber,
            //       //   ifsc: remitterAccountIfsc,
            //       //   name: remitterAccountName,
            //       // });
            //     }
            //   }
            // }
          /> */}
        </div>
        <div style={{ minWidth: 275 }}>
          <label style={styles.label}>Business Name</label>
          <CustomInput
            value={businessName}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Business Name"
            validator="businessName"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(data) => {
              setBusinessName(data);
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "20px 0px 0px 0px",
          gap: 20,
          marginBottom: 20,
        }}
      >
        <div style={{ minWidth: 275, marginRight: 75 }}>
          <label style={styles.label}>Legal Name</label>
          <CustomInput
            value={legalName}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Legal Name"
            validator="businessName"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(data) => {
              setLegalName(data);
            }}
          />
        </div>
        <div style={{ minWidth: 275, marginRight: 75 }}>
          <label style={styles.label}>Select Category</label>
          <CustomSelect
            value={businessType}
            options={Categories}
            placeholder={"Select the Category"}
            style={{
              ...containerStyle,
              position: "",
            }}
            onChange={(data) => {
              setBusinessType(data);
            }}
          />
        </div>
        <div style={{ minWidth: 275, marginRight: 75 }}>
          <label style={styles.label}>Business Address</label>
          <CustomInput
            value={businessAddress}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Business Address"
            type="input"
            validator={"address"}
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(data) => {
              setBusinessAddress(data);
            }}
          />
        </div>
        <div style={{ minWidth: 275, marginRight: 75 }}>
          <label style={styles.label}>DIN Check</label>
          <CustomInput
            value={dinCheck}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="DIN Check"
            type="input"
            validator="din"
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(data) => {
              setDinCheck(data);
            }}
          />
        </div>
        <div style={{ minWidth: 275, marginRight: 75 }}>
          <label style={styles.label}>DPAN Check</label>
          <CustomInput
            value={dpanCheck}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="DPAN Check"
            validator="pan"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(data) => {
              setDpanCheck(data);
            }}
          />
        </div>

        <div style={{ minWidth: 275, marginRight: 75 }}>
          <label style={styles.label}>Enter Website Link</label>
          <CustomInput
            value={websiteLink}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Enter Website Link"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            validator="websiteLink"
            onChange={(data) => {
              setWebsiteLink(data);
            }}
          />
        </div>
      </div>
      <div>
        <p style={styles.title}>IP Whitelisting</p>

        <div
          style={{
            padding: "20px 0px 20px 0px",
            minWidth: 200,
          }}
        >
          <label style={styles.label}>Enter IP(IPV4)</label>
          <CustomInput
            value={ipAddress}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Enter IP"
            type="input"
            inputStyles={{
              ...containerStyle,
              maxWidth: 275,
            }}
            validator="ipWhitelist"
            onChange={(data) => {
              setIpAddress([data]);
            }}
          />
        </div>
      </div>

      <div style={{ display: "flex", maxWidth: "340px" }}>
        <div>
          <CustomButton
            title="Cancel"
            styles={{
              background: "#FDFDFD",
              margin: "0 15px 0 0",
              maxWidth: "100px",
            }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{
              background: "#FDFDFD",
              margin: "0 15px 0 0",
              maxWidth: "100px",
            }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C", maxWidth: "100px" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
              const gstRegex =
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

              if (
                businessType !== "" &&
                gstNumber.length === 15 &&
                websiteLink !== "" &&
                businessName !== "" &&
                businessAddress !== "" &&
                legalName !== "" &&
                dinCheck.length === 8 &&
                dpanCheck.length === 10
              ) {
                if (ipAddress && !validateIPaddress(ipAddress)) {
                  enqueueSnackbar("Please enter Valid ipaddress", {
                    variant: "error",
                  });
                  return;
                }
                if (panRegex.test(dpanCheck) === false) {
                  enqueueSnackbar("Please enter Valid DPAN Number", {
                    variant: "error",
                  });
                  return;
                }
                if (gstRegex.test(gstNumber) === false) {
                  enqueueSnackbar("Please enter Valid GST Number", {
                    variant: "error",
                  });
                  return;
                }

                let arr = [];
                arr.push(ipAddress);
                onClickNext({
                  businessType: businessType.value,
                  gstNumber: gstNumber,
                  websiteLink: websiteLink,
                  businessName: businessName,
                  legalName: legalName,
                  address: businessAddress,
                  dinNumber: dinCheck,
                  dpan: dpanCheck,
                  ipWhitelist: arr,
                });
              } else {
                if (gstNumber.length < 15) {
                  enqueueSnackbar("Please enter Valid Gst Number", {
                    variant: "error",
                  });
                } else if (businessName === "") {
                  enqueueSnackbar("Please enter business name", {
                    variant: "error",
                  });
                } else if (legalName === "") {
                  enqueueSnackbar("Please enter Legal Name", {
                    variant: "error",
                  });
                } else if (businessType === "") {
                  enqueueSnackbar("Please Select business type", {
                    variant: "error",
                  });
                } else if (businessAddress === "") {
                  enqueueSnackbar("Please enter business Address", {
                    variant: "error",
                  });
                } else if (dinCheck.length < 8) {
                  enqueueSnackbar("Please enter valid DIN Number", {
                    variant: "error",
                  });
                } else if (dpanCheck === "" || dpanCheck.length < 10) {
                  enqueueSnackbar("Please enter valid DPAN Number", {
                    variant: "error",
                  });
                } else if (websiteLink === "") {
                  enqueueSnackbar("Please enter Website link", {
                    variant: "error",
                  });
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default BusinessDetailsNew;

const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: "linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content",
  },
  p: {
    color: "#6C6B6B",
    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    border: "1px solid #38369C",
    borderRadius: "8px",
  },
};
